import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ListItem from './ListItem';

type Props = React.ComponentProps<typeof ListItem>;

function NavListItemBase({ classes, ...restOfProps }: Props) {
  const classesOverride = useStyles();

  return <ListItem classes={{ root: classesOverride.root }} {...restOfProps} />;
}

const useStyles = makeStyles((theme: any) => ({
  root: {
    paddingTop: 1,
    paddingBottom: 1,
    color: theme.colors.navText,
    '&:hover,&:focus': {
      backgroundColor: theme.palette.primary.light,
    },
  },
}));

export default NavListItemBase;
